import React, { useContext } from 'react';
import {
  SET_DISPLAY_PROFILE_MODAL,
  SET_PROFILE_LAYOUT_TYPE,
} from 'containers/ProfileManager/redux/profile.types';
import { getAdminProfileId } from 'containers/ProfileManager/redux/profile.selectors';
import { getUserIsKids } from 'utils/User';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import { GenericButton } from 'components/GenericButton';
import { ProfileAvatar } from '../ProfileAvatar';
import { UserContext } from 'providers/user.provider';
import './style.scss';
import { AddProfileButton } from '../AddProfileButton';
import { OpcionMenuAdmin } from 'containers/MenuAvatar/components/OpcionMenuAdmin';
import { isKidProfile } from 'containers/NewSearchPage/utils/isKidProfile';
import { getRegion } from '../../../../utils/Region';
import getFirstNode from '../../../../utils/getFirstNode';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearRegisterUser } from 'utils/register';
import { useKidProfile } from 'containers/ProfileManager/hooks/useKidProfile';

export const MobileProfilesMenu = ({ onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { changeProfile } = useContext(UserContext);
  const user = useSelector(state => state.user);
  const adminUserId = useSelector(getAdminProfileId);
  const translations = useSelector(state => state.translations);
  const { profilesInfo } = useSelector(state => state?.profilesManager);
  const { isAdmin, gamification_id: gamification_id_current_usr } = useSelector(
    state => state.user,
  );
  const isKids = isKidProfile(profilesInfo?.members, gamification_id_current_usr) === 1;
  const { handlerChangeProfile } = useKidProfile()

  const handleChangeView = () => {
    clearRegisterUser();
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'MANAGE_PROFILES' });
    dispatch({ type: SET_DISPLAY_PROFILE_MODAL, payload: true });
    onClose && onClose();
  };

  const handleProfileSelect = (userHash, gamification_id) => {
    if (gamification_id_current_usr === gamification_id) {
      onClose && onClose();
      return;
    }
    handlerChangeProfile(userHash, profilesInfo, adminUserId, gamification_id, gamification_id_current_usr );
    onClose && onClose();
    if(location?.search?.includes('micuenta') || location.pathname?.includes('vcard')){
      navigate(`/${getRegion()}/${getFirstNode()}`);
    }
  };

  return (
    <>
      <div className="mobile-profiles-menu__list">
        {profilesInfo?.members?.map(profile => (
          <ProfileAvatar
            key={`menu-select-profile-key-${profile.partnerUserId}`}
            avatarSrc={profile?.user_image}
            profileName={profile?.username}
            onClick={() =>
              handleProfileSelect(profile?.user_hash, profile?.gamification_id)
            }
            menuView={true}
            selected={profile.gamification_id === user.gamification_id}
          />
        ))}
        {profilesInfo?.members?.length < profilesInfo?.maxMembers && !isKids && (
          <AddProfileButton menuView={true} onClose={onClose} />
        )}
      </div>
      {!isKids && (
        <GenericButton
          onClick={handleChangeView}
          type="secondary"
          textContent={getTranslation(
            'listProfiles_access_option_button_manageProfiles',
            translations,
          )}
          classNames={['mobile-profiles-menu__button']}
        />
      )}
    </>
  );
};
